import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import TextArea from "components/atoms/input/TextArea";
import { ValidateWord } from "components/atoms/text/Text";
import { UserGroupCURequest } from "api/interfaces/userInterface.interface";
import { UPDATE_TYPE } from "../AddUserGroupContainer";

interface PreferencesStepPageProps {
  isEditableUser: boolean;
  userGroup: UserGroupCURequest;
  groupNameValidate: boolean;
  groupNameValidateMsg: string;
  onFocusPreferencePage: () => void;
  onChangeGroupInfo: (type: UPDATE_TYPE, value: any) => void;
}

export default function PreferencesStepPage(
  props: PreferencesStepPageProps
): JSX.Element {
  return (
    <>
      <ModalInput label="Group Name" essential>
        <Input
          placeholder="Please enter a name"
          disabled={!props.isEditableUser}
          defaultValue={props.userGroup.name}
          onChange={(e) =>
            props.onChangeGroupInfo(UPDATE_TYPE.NAME, e.target.value)
          }
          isValidated={props.groupNameValidate}
          onFocus={props.onFocusPreferencePage}
          maxLength={255}
          data-testid="users-user-group-pages-input-change-group-info"
        />

        <ValidateWord data-testid="users-user-group-pages-validate-group-name">
          {props.groupNameValidateMsg}
        </ValidateWord>
      </ModalInput>
      <ModalInput label="Description">
        <TextArea
          placeholder="Please enter a description"
          disabled={!props.isEditableUser}
          defaultValue={props.userGroup.description}
          onChange={(e) =>
            props.onChangeGroupInfo(UPDATE_TYPE.DESC, e.target.value)
          }
          maxLength={255}
          data-testid="users-user-group-pages-textarea-change-group-info"
        />
      </ModalInput>
    </>
  );
}
